import { SET_CURRENCY } from './types';

// eslint-disable-next-line import/prefer-default-export
export const setCurrency = currency => ({ type: SET_CURRENCY, currency });
